import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_ALL_TERMS_QUERY, DOWNLOAD_APPLICANTS_MUTATION } from "../../graphQL/term_qry";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Grid,
  Typography,
  Divider,
  Button,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import Header from "./Header.js";

import AlertDialog from "../../components/AlertDialog.js";
import SelectTermsDialog from "./SelectTermsDialog";
import { project_url } from "../../constants/Data";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  buttonStyle: {
    borderRadius: 4,
    // width: "250px",
    // padding: 0,
    color: "#fff",
    // height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  selectStyle: {
    // marginTop: 10,
    borderRadius: "15px",
    minWidth: 250,
    height: 35,
    // marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
}));

function DownloadApplicantsReport() {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [selectedTerms, setSelectedTerms] = useState(["ALL"]);
  const [selectedTermNames, setSelectedTermNames] = useState([""]);
  const [selectedData, setSelectedData] = useState("info");
  const [openSelectTermsDialog, setOpenSelectTermsDialog] = useState(null);
  const [alertDownloadApplicantMsg, setAlertDownloadApplicantMsg] = useState([]);
  const [errorMsg, setErrorMsg] = useState({
    selectedTerm: "",   
  });
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  
  const tenantName = localStorage.getItem("tenantName");
  const clientName = localStorage.getItem("clientName");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");
  
  const [viewAccess, setViewAccess] = useState(true);
  
  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Reports",
              modulepageName: "Download Applicants"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      if(commonActions.find(a => a === "View")){
        setViewAccess(true);}
      else {setViewAccess(false);}
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }
  
  const [clientTermList, setClientTermList] = useState([]);
  const [fetchAllTerms] = useManualQuery(GET_ALL_TERMS_QUERY, {
    fetchPolicy: "network-only",
  });
  const getTermsList = async () => {
    const {
      loading: termsListLoading,
      error: termsListError,
      data: termsListData,
    } = await fetchAllTerms({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!termsListLoading && termsListData && termsListData.allTerms) {
      console.log(termsListData.allTerms);
      const activeTerms = termsListData.allTerms.filter(
        term => term.urlActivated === true
      );
      setClientTermList(activeTerms);
      
      for (var i in activeTerms) {
        let currTerm = activeTerms[i];        
        if (currTerm.current){
          console.log(parseInt(currTerm.termId));
          setSelectedTerms([parseInt(currTerm.termId)]);
          setSelectedTermNames(currTerm.name + " (Current Name)");
        }
      }
    }
    if (
      termsListError &&
      termsListError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin/?next=${pathname}`);
    }
    console.log(selectedTerms);
  };

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermsList())();
  }, []);
  
  const handleSelectTerms = () => {
    setOpenSelectTermsDialog({
      tenantName: tenantName,
      clientName: clientName,
      clientTermList: clientTermList,
      selectedTerms: selectedTerms
    });
  };
 
  const confirmDownload = () => {
    setAlertDownloadApplicantMsg({
        title: "Download Applicants",
        type: "downloadApplicantsReport",
        msg: "Are you ready to run this report?",
      });
  }
  const getSelectedTermIds = () => {
    return selectedTerms.filter(v => v !== "ALL");
  };
  const [downloadApplicants] = useMutation(DOWNLOAD_APPLICANTS_MUTATION, {
    fetchPolicy: "network-only",
  });
  const handleDownload = async () => {
    console.log("handleDownloadApplicants");
    const selectedTermIds = getSelectedTermIds();
    console.log(selectedTermIds);
    if (selectedTermIds.length === 0) {
      setErrorMsg({ ...errorMsg, selectedTerm: "Select a term." });
      return;
    } else
    {
        const { data, error } = await downloadApplicants({
          variables: {
            termIds: selectedTermIds,
            dataType: selectedData,
          },
        });
        if (
            error &&
            error.graphQLErrors
          ){
          console.log("Error", error, data);
        } else if (data && data.downloadApplicants) {
          console.log("Success", data);
          window.open(data.downloadApplicants.url, "_blank");
        }
    }
  };
  
  if (loadContent)
  if (viewAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: 'Download Applicants', link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Download Applicants
            </Typography>
          </Box>
          <Divider />
          <Grid container spacing={3} style={{ marginTop: 30 }}>
            <Grid item xs={4}>       
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                type="button"
                onClick={handleSelectTerms}
                disabled={clientTermList.length === 0}
                style={{ marginTop: 10 }}
              >
                Select Terms
              </Button>         
            </Grid>
            <Grid item xs={4}>
              <Box
                  pt={2}
                  display="flex"
                  flexDirection="row"
                  alignItems="flex-start"
                  width="100%"
              >
                <Typography style={{ marginRight: 12, marginTop: 5 }} variant="h2">
                  Select Data Set:
                </Typography>
                <Box pl={1}>
                  <Select
                    className={classes.selectStyle}
                    margin="normal"
                    value={selectedData}
                    onChange={e => setSelectedData(e.target.value)}
                  >
                        <MenuItem value="info">Applicant Info</MenuItem>
                        <MenuItem value="answers">Applicant Answers (Vertical)</MenuItem>
                        <MenuItem value="answers_horizontal">Applicant Answers (Horizontal)</MenuItem>
                        <MenuItem value="both">Both Data Sets</MenuItem>
                  </Select>
                </Box>
              </Box>
            </Grid>
            </Grid>
                          <Typography mt={10} style={{ marginRight: 12, marginTop: 20 }} variant="h2">
                {clientTermList.length === 0 ? (
                  <span>There is no active term.</span>
                 ) : (
                  <span>Selected Terms: <span style={{ fontWeight: 400 }}>{ selectedTermNames }</span></span>
                )}
              </Typography>     
            <Box
              pt={4}
              pb={2}
              display="flex"
              justifyContent="center"
            >
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                type="button"
                disabled={selectedTerms.length === 0 || clientTermList.length === 0}
                onClick={confirmDownload}
              >
                Download Applicants
              </Button>
            </Box>
            
            {openSelectTermsDialog && (
              <SelectTermsDialog
                tenantName={openSelectTermsDialog.tenantName}
                clientName={openSelectTermsDialog.clientName}
                clientTermList={openSelectTermsDialog.clientTermList}
                outerSelectedTerms={openSelectTermsDialog.selectedTerms}
                onDone={(ids, names) => {
                  setSelectedTerms(ids);
                  setSelectedTermNames(names.join(", "));
                  setOpenSelectTermsDialog(null);
                }}
                closeDialog={() => setOpenSelectTermsDialog(null)}
              />
            )}
            {alertDownloadApplicantMsg.msg && (
            <AlertDialog
              title={alertDownloadApplicantMsg.title}
              type={alertDownloadApplicantMsg.type}
              contentMsg={alertDownloadApplicantMsg.msg}
              closeDialog={() => setAlertDownloadApplicantMsg([])}
              goDonwloadApplicantAction={() => {
                setAlertDownloadApplicantMsg([]);
                handleDownload();
              }}
            />
            )}
        </div>
      </div>
      );
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Term"
                contentMsg='There is no term in this Tenant. Please create a term.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
      
  else return;
}

export default DownloadApplicantsReport;
